/**
 * モバイルデバイス以外の場合、tel:リンクを不活化
 */

import $ from 'jquery';

$(function () {
  // タッチデバイスかどうかを判定（より確実な方法）
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

  // PC（タッチデバイス以外）の場合、tel:リンクを不活化
  if (!isTouchDevice) {
    $('a[href^="tel:"]').each(function () {
      const $this = $(this);

      // hrefを保存してから削除
      $this.data('original-href', $this.attr('href'));
      $this.removeAttr('href');

      // スタイルを変更
      $this.css({
        cursor: 'text',
        'text-decoration': 'none',
      });

      // クリックイベントを無効化
      $this.on('click', function (e) {
        e.preventDefault();
        return false;
      });
    });
  }
});
